(function () {
  'use strict';

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderProperties(properties) {
    if (!properties) return '';

    var html = '';
    Object.keys(properties).forEach(function (key) {
      var value = properties[key];
      if (!value || key.charAt(0) === '_') return;

      html +=
        '<p class="mini-cart-property mb-1">' +
        '<strong>' +
        escapeHtml(key) +
        ':</strong> ' +
        escapeHtml(value) +
        '</p>';
    });

    return html;
  }

  function augmentMiniCartItems(cart) {
    var items = document.querySelectorAll('.js-mini-cart-content .mini-cart-item');
    if (!items.length || !cart || !cart.items) return;

    cart.items.forEach(function (product, index) {
      var itemEl = items[index];
      if (!itemEl) return;

      var meta = itemEl.querySelector('.mini-cart-meta');
      if (!meta) return;

      meta.querySelectorAll('.mini-cart-property').forEach(function (node) {
        node.remove();
      });

      var html = renderProperties(product.properties);
      if (!html) return;

      var title = meta.querySelector('.mb-1');
      if (title) {
        title.insertAdjacentHTML('afterend', html);
      } else {
        meta.insertAdjacentHTML('afterbegin', html);
      }
    });
  }

  function patchMiniCart() {
    if (!window.theme || !window.theme.miniCart || window.theme.miniCart._linePropertiesPatched) return;

    var originalGenerate = window.theme.miniCart.generateCart;
    if (typeof originalGenerate !== 'function') return;

    window.theme.miniCart.generateCart = function () {
      originalGenerate.apply(this, arguments);

      if (typeof Shopify !== 'undefined' && typeof Shopify.getCart === 'function') {
        Shopify.getCart(augmentMiniCartItems);
      }
    };

    window.theme.miniCart._linePropertiesPatched = true;
  }

  function boot() {
    patchMiniCart();
  }

  document.addEventListener('DOMContentLoaded', boot);

  var timer = window.setInterval(function () {
    if (window.theme && window.theme.miniCart) {
      patchMiniCart();
      window.clearInterval(timer);
    }
  }, 200);

  window.setTimeout(function () {
    window.clearInterval(timer);
  }, 15000);
})();
